<template>
  <div style="height: 100%" v-wechat-title="$route.meta.title = title()">
    <van-tabs v-model="activeName" color="#409eff" @change="onChange">
      <van-tab name="a" title="节目">
        <programList></programList>
      </van-tab>
      <van-tab name="b" title="任务">
        <taskList @itemName="itemName" @changeItemShow="changeItemShow"></taskList>
      </van-tab>
      <van-tab name="c" title="进度">
        <taskProgress></taskProgress>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import programList from '../components/programList'
import taskList from '../components/taskList'
import taskProgress from '../components/taskProgress'


export default {
  name: 'Programs',
  data() {
    return {
      activeName: 'a',
    }
  },
  mounted() {
    document.title = '节目管理'
    this.activeName = this.$route.query.itemName
  },
  components: {
    programList,
    taskList,
    taskProgress
  },
  methods: {
    itemName(res) {
      this.activeName = res
    },
    onChange(event) {
      this.activeName = event;
    },
    changeItemShow(data) {
      this.activeName = data
    },
    title() {
      switch (this.activeName) {
        case 'a':
          return '节目'
        case 'b':
          return '任务'
        case 'c':
          return '进度'
      }
    }
  }
}
</script>

<style lang="scss">
.van-tabs {
  height: 100%;
}

.van-tabs__content {
  height: calc(100% - 44px);

  .van-tab__pane {
    height: 100%;

    .programList {
      height: 100%;

      .content {
        height: calc(100% - 40px);
      }
    }
  }
}

</style>
